import { ref, onMounted } from 'vue'
import axios from 'axios'

const impersonatedUser = ref(null)
const realUser = ref(null)
const isImpersonating = ref(false)

export function useImpersonation() {
    const fetchUser = async () => {
        try {
            const { data } = await axios.get('/api/user', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                    withCredentials: true
                }
            })

            if (data.real_user) {
                isImpersonating.value = true
                impersonatedUser.value = data.user
                realUser.value = data.real_user
            } else {
                isImpersonating.value = false
                impersonatedUser.value = null
                realUser.value = null
            }
        } catch (e) {
            console.error('Error fetching user for impersonation')
        }
    }

    const stopImpersonation = async () => {
        try {
            const { data } = await axios.post('/api/impersonate/stop', {}, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })

            console.log(data);

            localStorage.setItem('token', data.token)
            window.location.reload()
        } catch (e) {
            console.error('Error stopping impersonation')
        }
    }

    onMounted(fetchUser)

    return {
        impersonatedUser,
        realUser,
        isImpersonating,
        stopImpersonation
    }
}
